import { Feature } from '@tencent/workbench';
import BaseTitleBarFeature from '@framework/workbench/common/feature/base-titlebar-feature';
import { LocalEditServices } from '@src/slide/domain/slide-app/scenes/local-edit/core/local-edit-services.core';

@Feature()
export default class LocalFileSaveAsFeature extends BaseTitleBarFeature {
    public handleClickSaveAs(): void {
        LocalEditServices.LocalEditManager.promise().then(manager => manager.saveAs());
    }

    public handleClickSave(): void {
        LocalEditServices.LocalEditManager.promise().then(manager => manager.save());
    }
}
